import { render } from "./LayoutPostList.vue?vue&type=template&id=327d477d"
import script from "./LayoutPostList.vue?vue&type=script&lang=js"
export * from "./LayoutPostList.vue?vue&type=script&lang=js"

import "./LayoutPostList.vue?vue&type=style&index=0&id=327d477d&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__